'use strict';

angular.module('ClinicApp').directive('ngMatch', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      ngMatch: '=',
    },
    link: function($scope, _elem, _attrs, ctrl) {
      $scope.$watch(function() {
        return (
          (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue))
          || $scope.ngMatch === ctrl.$modelValue
        );
      }, function(currentValue) {
        ctrl.$setValidity('match', currentValue);
      });
    },
  };
});
